import { MultiUserLockIllustration } from '@carboncopyco/illustrations';
import { Button, Modal, TextBase, TextSubHeader } from '@carboncopyco/ui';

type AssetLockedModalProps = {
  userName: string;
  buttonLabel: string;
  onButtonClick: () => void;
};

export const AssetLockedModal = ({
  userName,
  buttonLabel,
  onButtonClick,
}: AssetLockedModalProps) => {
  return (
    <Modal
      open
      removeCloseIcon
      containerClass="w-[606px]"
    >
      <div className="py-7 px-9 flex flex-col items-center">
        <div className="pb-6">
          <MultiUserLockIllustration
            width={'191px'}
            height={'91px'}
          />
        </div>
        <div className="pb-4">
          <TextSubHeader label="Edit Unavailable: Currently in Use by Another User" />
        </div>
        <div className="pb-6 flex">
          <TextBase
            color="text-ds-natural-600"
            textAlign="text-center"
            label={`This asset is currently being edited by ${userName}. To avoid potential conflicts and ensure all changes are saved correctly, please wait until the asset is unlocked by the other editor. You will then have access to the most updated version for editing.`}
          />
        </div>

        <Button
          label={buttonLabel || 'Go to Homepage'}
          onClick={onButtonClick}
        />
      </div>
    </Modal>
  );
};
